module.exports = __webpack_public_path__ + "img/no_order.9214fe2a.svg";